import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RegistrationComponent } from './authentication/registration/registration.component';
import { LoginComponent } from './authentication/login/login.component';
import { MicrosoftSsoComponent } from './authentication/sso-handler/sso-handler.component';
// import { DashboardComponent } from './dashboard/dashboard.component';
import { CreateClientComponent } from './clients/create/create-client.component';
import { ClientListComponent } from './clients/list/client-list.component';
import { CategoriesListComponent } from './categories/categories-list/categories-list.component';
import { ActivitiesListComponent } from './activities/activities-list/activities-list.component';
import { ProjectListComponent } from './projects/list/project-list.component';
import { AuthGuard } from './guards/auth.guard';
import { RoleGuard } from './guards/role.guard';
// import { EditProjectComponent } from './projects/edit/edit-project.component';
// import { ShowProjectComponent } from './projects/show/show-project.component';
// import { CreateProjectComponent } from './projects/create/create-project.component';
import { EditClientComponent } from './clients/edit/edit-client.component';
import { AccountListComponent } from './accounts/list/account-list.component';
import { CreateAccountComponent } from './accounts/create/create-account.component';
import { EditAccountComponent } from './accounts/edit/edit-account.component';
import { ShowComponent } from './accounts/show/show.component';
import { GoalsListComponent } from './goals/list/goals-list.component';
import { EditGoalComponent } from './goals/edit/edit-goal.component';
import { CreateGoalComponent } from './goals/create/create-goal.component';
import { ShowGoalComponent } from './goals/show/show-goal.component';
import { AccountsMetricsComponent } from './accounts/metrics/accounts-metrics.component';
import { CreateTimesheetComponent } from './timesheets/create-timesheet/create-timesheet.component';
import { ImportTimesheetComponent } from './timesheets/import-timesheet/import-timesheet.component';
import { ListTimesheetComponent } from './timesheets/list-timesheet/list-timesheet.component';
import { EditTimesheetComponent } from './timesheets/edit-timesheet/edit-timesheet.component';
import { ChartsComponent } from './timesheets/charts/charts.component';
// import { ListComponent } from './accountGoals/list/list.component';
// import { CreateComponent } from './accountGoals/create/create.component';
// import { EditComponent } from './accountGoals/edit/edit.component';
import { ListAccountMetricsComponent } from './accountMetrics/list-account-metrics/list-account-metrics.component';
import { CreateAccountMetricsComponent } from './accountMetrics/create-account-metrics/create-account-metrics.component';
import { EditAccountMetricsComponent } from './accountMetrics/edit-account-metrics/edit-account-metrics.component';
import { TeamGoalsComponent } from './accountGoals/team-goals/team-goals.component';
// import { DuplicateComponent } from './accountGoals/duplicate/duplicate.component';
import { SettingsComponent } from './settings/settings.component';
import { ListTemplatesComponent } from './templates/list-templates/list-templates.component';
import { CreateTemplatesComponent } from './templates/create-templates/create-templates.component';
import { EditTemplatesComponent } from './templates/edit-templates/edit-templates.component';
import { ShowTemplateComponent } from './templates/show-template/show-template.component';
import { CreateTemplateMetricsComponent } from './template-metrics/create-template-metrics/create-template-metrics.component';
import { EditTemplateMetricsComponent } from './template-metrics/edit-template-metrics/edit-template-metrics.component';
import { ListTemplateMetricsComponent } from './template-metrics/list-template-metrics/list-template-metrics.component';
import { ReportComponent } from './report/report.component';
import { CalculatorComponent } from './calculator/calculator.component';
import { AdminChartsComponent } from './timesheets/admin-charts/admin-charts.component';
import { TeamListComponent } from './team/team-list/team-list.component';
import { ProjectComponent } from './projects/project/project.component';
import { ShowProjectComponent } from './projects/show/show-project.component';
import { CreateProjectComponent } from './projects/create/create-project.component';
import { ReimbursementAddFormComponent } from './reimbursement/reimbursement-add-form/reimbursement-add-form.component';
import { ReimbursementListComponent } from './reimbursement/reimbursement-list/reimbursement-list.component';
import { ReimbursementUserEditComponent } from './reimbursement/reimbursement-user-edit/reimbursement-user-edit.component';
import { ReimbursementViewItemsListComponent } from './reimbursement/reimbursement-view-items-list/reimbursement-view-items-list.component';
import { ReimbursementManagerListComponent } from './reimbursement/reimbursement-manager-list/reimbursement-manager-list.component';
import { ReimbursementManagerViewComponent } from './reimbursement/reimbursement-manager-view/reimbursement-manager-view.component';
import { ReimbursementAdminListComponent } from './reimbursement/reimbursement-admin-list/reimbursement-admin-list.component';
import { ReimbursementAdminViewComponent } from './reimbursement/reimbursement-admin-view/reimbursement-admin-view.component';
import { ReimbursementManagerItemsListComponent } from './reimbursement/reimbursement-manager-items-list/reimbursement-manager-items-list.component';
import { CreateCategoryComponent } from './skill-matrix/create-category/create-category.component';
import { ListCategoryComponent } from './skill-matrix/list-category/list-category.component';
import { EditCategoryComponent } from './skill-matrix/edit-category/edit-category.component';
import { SkillUpdateComponent } from './skill-matrix/skill-update/skill-update.component';
import { ListSkillComponent } from './skill-matrix/list-skill/list-skill.component';
import { EditSkillComponent } from './skill-matrix/edit-skill/edit-skill.component';
import { CreateSkillComponent } from './skill-matrix/create-skill/create-skill.component';
import { AdminFilterComponent } from './skill-matrix/admin-filter/admin-filter.component';
import { FilterSkillDetailComponent } from './skill-matrix/filter-skill-detail/filter-skill-detail.component';
import { UserDetailComponent } from './skill-matrix/user-detail/user-detail.component';
import { AdminBlogPostComponent } from './blog/admin-blog-post/admin-blog-post.component';
import { ListBlogComponent } from './blog/list-blog/list-blog.component';
import { EditBlogComponent } from './blog/edit-blog/edit-blog.component';
import { UserListBlogComponent } from './blog/user-list-blog/user-list-blog.component';
import { VariablePayReportComponent } from './variable-pay-report/variable-pay-report.component';
import { VariablePayComponent } from './variable-pay/variable-pay.component';
import { QuestionslistComponent } from './questions/list/list.component';
import { QuestionscreateComponent } from './questions/create/create.component';
import { QuestionseditComponent } from './questions/edit/edit.component';
import { OffboardingComponent } from './offboarding/offboarding.component';
import { PersonalDetailsComponent } from './offboarding/personal-details/personal-details.component';
import { ExitFormComponent } from './offboarding/exit-form/exit-form.component';
import { ExitChecklistComponent } from './offboarding/exit-checklist/exit-checklist.component';
import { PersonalDetailComponent } from './offboarding/forms-view/personal-detail/personal-detail.component';
import { ExitInterviewComponent } from './offboarding/forms-view/exit-interview/exit-interview.component';
import { ExitChecklistViewsComponent } from './offboarding/forms-view/exit-checklist-views/exit-checklist-views.component';
import { ExitChecklistViewManagerComponent } from './offboarding/forms-view/exit-checklist-view-manager/exit-checklist-view-manager.component';
import { ExitChecklistViewSysadminComponent } from './offboarding/forms-view/exit-checklist-view-sysadmin/exit-checklist-view-sysadmin.component';
import { ExitChecklistHrComponent } from './offboarding/forms-view/exit-checklist-hr/exit-checklist-hr.component';
import { SortingQuestionsComponent } from './questions/sorting-questions/sorting-questions.component';
import { AdminGuard } from './guards/admin.guard';
import { IsNotAdminGuard } from './guards/isNot-admin.guard';
import { IsNotReimbursementManagerGuard } from './guards/isNot-reimbursement_manager.guard';
import { DontHaveAccessGuard } from './guards/dont-have-access.guard';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

const appRoutes: Routes = [

  { path: 'login', component: LoginComponent },
  { path: 'sso-handler', component: MicrosoftSsoComponent },
  { path: 'signup', component: RegistrationComponent },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  // { path: '**', pathMatch: 'full', 
  //       component: PageNotFoundComponent },
  {
    path: '', canActivate: [AuthGuard], children: [
      { path: 'offboarding/personal-details', component: PersonalDetailsComponent },
      { path: 'offboarding/exit-form', component: ExitFormComponent },
      { path: 'offboarding/exit-checklist', component: ExitChecklistComponent },
      { path: 'the-personal-detail-view/:id', component: PersonalDetailComponent },
      { path: 'the-exit-interview-view/:id', component: ExitInterviewComponent },
      { path: 'the-exit-checklist-view/:emp/:id', component: ExitChecklistViewsComponent },
      { path: 'the-exit-checklist-view-manager/:id', component: ExitChecklistViewManagerComponent },
      { path: 'the-exit-checklist-view-sysadmin/:id', component: ExitChecklistViewSysadminComponent },
      { path: 'the-exit-checklist-hr/:id', component: ExitChecklistHrComponent },
      { path: 'dashboard',canActivate: [DontHaveAccessGuard], loadChildren: './dashboard/dashboard.module#DashboardModule' },
      { path: 'timesheet/new',canActivate: [DontHaveAccessGuard],  component: CreateTimesheetComponent },
      { path: 'timesheet/import',canActivate: [DontHaveAccessGuard], component: ImportTimesheetComponent },
      { path: 'timesheets',canActivate: [DontHaveAccessGuard], component: ListTimesheetComponent },
      { path: 'charts',canActivate: [DontHaveAccessGuard], component: ChartsComponent },
      { path: 'admin-reports',canActivate: [DontHaveAccessGuard], component: AdminChartsComponent },
      // { path: 'account/:id/accountGoals', component: ListComponent },
      {
        path: 'account/:id/accountGoals',
        loadChildren: 'app/accountGoals/account-goals.module#AccountGoalsModule'
      },
      { path: 'teamGoals', component: TeamGoalsComponent },
      { path: 'myTeams',canActivate: [DontHaveAccessGuard], component: TeamListComponent },
      //Due to hiding this feature, this page has redirected to dashboard page using DontHaveAccessGuard
      { path: 'myProjects', canActivate: [DontHaveAccessGuard], component: ProjectComponent},
      { path: 'calculator', component: CalculatorComponent },
      { path: 'timesheet/:id/edit',canActivate: [DontHaveAccessGuard], component: EditTimesheetComponent },
      { path: 'account/:id/accountGoals/:accountGoal_id/metrics/new', component: CreateAccountMetricsComponent },
      { path: 'account/:id/accountGoals/:accountGoal_id/metrics/:accountMetric_id/edit', component: EditAccountMetricsComponent },
      { path: 'accountGoals/:accountGoal_id/metrics', component: ListAccountMetricsComponent },
      { path: 'skillUpdate',canActivate: [DontHaveAccessGuard], component: SkillUpdateComponent },
      { path: 'userBlogList', component:UserListBlogComponent },
      { path: 'adminBlogPost', component: AdminBlogPostComponent },
      { path: 'blogList', component: ListBlogComponent },
      { path: 'blog/edit/:id', component:EditBlogComponent },
      // { path: 'userSearchBlog', component:UserSearchBlogComponent },
      { path: 'reimbursement/add', component: ReimbursementAddFormComponent },
      { path: 'reimbursement/list',canActivate: [DontHaveAccessGuard], component: ReimbursementListComponent },
      { path: 'reimbursement/edit/:id', component: ReimbursementUserEditComponent },
      { path: 'reimbursement/view/:id', component: ReimbursementViewItemsListComponent },
      { path: 'reimbursement/manager/items/view/:id', component: ReimbursementManagerItemsListComponent },
      { path: 'reimbursement/manager/list',canActivate: [DontHaveAccessGuard], component: ReimbursementManagerListComponent },
      { path: 'reimbursement/manager/view/:id', component: ReimbursementManagerViewComponent },
      { path: 'reimbursement/admin/list',canActivate: [DontHaveAccessGuard], component: ReimbursementAdminListComponent },
          { path: 'reimbursement/admin/view/:id', component: ReimbursementAdminViewComponent },
      {
        path: '', canActivate: [RoleGuard], children: [
          { path: 'offboarding', component:OffboardingComponent},
          // { path: 'questions/list', component:QuestionslistComponent},
          // { path: 'questions/create', component:QuestionscreateComponent},
          // { path: 'questions/:id/edit', component:QuestionseditComponent},
          // { path: 'sort-questions', component:SortingQuestionsComponent},
          // { path: 'dashboard', loadChildren: './dashboard/dashboard.module#DashboardModule' },
          { path: 'settings', component: SettingsComponent },
          { path: 'templates', component: ListTemplatesComponent },
          // { path: 'templates/:id/metrics', component: ShowTemplateComponent  },
          { path: 'templates/new', component: CreateTemplatesComponent },
          { path: 'templates/:id/edit', component: EditTemplatesComponent },
          { path: 'templates/:id/metrics/new', component: CreateTemplateMetricsComponent },
          { path: 'templates/:id/metrics', component: ListTemplateMetricsComponent },
          { path: 'templates/:id/metrics/:templateMetric_id/edit', component: EditTemplateMetricsComponent },
          { path: 'reports', component: ReportComponent },
          { path: 'client/new', component: CreateClientComponent },
          { path: 'clients',canActivate: [DontHaveAccessGuard], component: ClientListComponent },
          { path: 'categories',canActivate: [DontHaveAccessGuard], component: CategoriesListComponent },
          { path: 'activities',canActivate: [DontHaveAccessGuard], component: ActivitiesListComponent },
          { path: 'client/:id', component: EditClientComponent },
          { path: 'client/:id', component: EditClientComponent },
          { path: 'project/new', component: CreateProjectComponent },
          { path: 'projects', component: ProjectListComponent },
          // { path: 'project/new', component: CreateProjectComponent },
          // { path: 'project/:id/edit', component: EditProjectComponent },
          { path: 'project/:id', component: ShowProjectComponent },
          { path: 'accounts', component: AccountListComponent },
          { path: 'account/new', component: CreateAccountComponent },
          { path: 'account/:id/edit', component: EditAccountComponent },
          { path: 'account/:id', component: ShowComponent },
          // { path: 'account/:id/accountGoals/new', component: CreateComponent },
          // { path: 'account/:id/accountGoals/:accountGoal_id/edit', component: EditComponent },
          // { path: 'account/:id/accountGoals/:accountGoal_id/duplicate', component: DuplicateComponent },
          // { path: 'account/:id/accountGoals/:accountGoal_id/delete', component: EditComponent },
          { path: 'accounts/:id/metrics', component: AccountsMetricsComponent },
          { path: 'goals', component: GoalsListComponent },
          {
            path: 'account/:id/accountGoals',
            loadChildren: 'app/accountGoals/account-goals.module#AccountGoalsModule'
          },
          { path: 'teamGoals', component: TeamGoalsComponent },
          { path: 'myTeams',canActivate: [DontHaveAccessGuard], component: TeamListComponent },
          //Due to hiding this feature, this page has redirected to dashboard page using DontHaveAccessGuard
          { path: 'myProjects',canActivate: [DontHaveAccessGuard], component: ProjectComponent },
          { path: 'calculator', component: CalculatorComponent },
          { path: 'categoryList',canActivate: [DontHaveAccessGuard], component: ListCategoryComponent },
          { path: 'category/new', component: CreateCategoryComponent },
          { path: 'category/edit/:id', component: EditCategoryComponent },
          { path: 'skillList',canActivate: [DontHaveAccessGuard], component: ListSkillComponent },
          { path: 'skill/edit/:id', component: EditSkillComponent },
          { path: 'byUser/:id', component: UserDetailComponent },
          { path: 'skill/new', component: CreateSkillComponent },
          { path: 'adminFilter',canActivate: [DontHaveAccessGuard], component: AdminFilterComponent },

          { path: 'adminBlogPost', component: AdminBlogPostComponent },
          { path: 'blogList', component: ListBlogComponent },
          { path: 'blog/edit/:id', component:EditBlogComponent },
          // { path: 'searchBlog', component:SearchBlogComponent },
          { path: 'timesheet/:id/edit',canActivate: [DontHaveAccessGuard], component: EditTimesheetComponent },
          { path: 'account/:id/accountGoals/:accountGoal_id/metrics/new', component: CreateAccountMetricsComponent },
          { path: 'account/:id/accountGoals/:accountGoal_id/metrics/:accountMetric_id/edit', component: EditAccountMetricsComponent },
          { path: 'accountGoals/:accountGoal_id/metrics', component: ListAccountMetricsComponent },
          {
            path: '', canActivate: [RoleGuard], children: [

              // { path: 'dashboard', loadChildren: './dashboard/dashboard.module#DashboardModule' },
              { path: 'settings', component: SettingsComponent },
              { path: 'templates', component: ListTemplatesComponent },
              // { path: 'templates/:id/metrics', component: ShowTemplateComponent  },
              { path: 'templates/new', component: CreateTemplatesComponent },
              { path: 'templates/:id/edit', component: EditTemplatesComponent },
              { path: 'templates/:id/metrics/new', component: CreateTemplateMetricsComponent },
              { path: 'templates/:id/metrics', component: ListTemplateMetricsComponent },
              { path: 'templates/:id/metrics/:templateMetric_id/edit', component: EditTemplateMetricsComponent },
              { path: 'reports', component: ReportComponent },
              { path: 'client/new', component: CreateClientComponent },
              { path: 'clients',canActivate: [DontHaveAccessGuard], component: ClientListComponent },
              { path: 'categories',canActivate: [DontHaveAccessGuard], component: CategoriesListComponent },
              { path: 'activities',canActivate: [DontHaveAccessGuard], component: ActivitiesListComponent },
              { path: 'client/:id', component: EditClientComponent },
              { path: 'client/:id', component: EditClientComponent },
              { path: 'project/new', component: CreateProjectComponent },
              { path: 'projects', component: ProjectListComponent },
              // { path: 'project/new', component: CreateProjectComponent },
              // { path: 'project/:id/edit', component: EditProjectComponent },
              { path: 'project/:id', component: ShowProjectComponent },
              { path: 'accounts', component: AccountListComponent },
              { path: 'account/new', component: CreateAccountComponent },
              { path: 'account/:id/edit', component: EditAccountComponent },
              { path: 'account/:id', component: ShowComponent },
              // { path: 'account/:id/accountGoals/new', component: CreateComponent },
              // { path: 'account/:id/accountGoals/:accountGoal_id/edit', component: EditComponent },
              // { path: 'account/:id/accountGoals/:accountGoal_id/duplicate', component: DuplicateComponent },
              // { path: 'account/:id/accountGoals/:accountGoal_id/delete', component: EditComponent },
              { path: 'accounts/:id/metrics', component: AccountsMetricsComponent },
              { path: 'goals', component: GoalsListComponent },
              {
                path: 'project',
                loadChildren: 'app/projects/projects.module#ProjectsModule'
              },
              {
                path: 'goal',
                loadChildren: 'app/goals/goals.module#GoalsModule'
              },

              // { path: 'goal/:id/edit', component: EditGoalComponent },
              // { path: 'goal/new', component: CreateGoalComponent },
              // { path: 'goal/:id', component: ShowGoalComponent }
              { path: 'variablepay-reports', component: VariablePayReportComponent },
              { path: 'variablepay', component: VariablePayComponent }
            ]
          }
        ]
      },
      {
        path: '', canActivate: [AdminGuard], children: [
          { path: 'questions/list', component:QuestionslistComponent},
          { path: 'questions/create', component:QuestionscreateComponent},
          { path: 'questions/:id/edit', component:QuestionseditComponent},
          // { path: 'sort-questions', component:SortingQuestionsComponent},
        ]
      },
      
      //Due to hiding this feature, this page has redirected to dashboard page using DontHaveAccessGuard
      {
        path: 'wfh',
        canActivate: [DontHaveAccessGuard],
        // canActivate: [AuthGuard],
        loadChildren: 'app/work-from-home/work-from-home.module#WorkFromHomeModule',
      }
    ]
  }
]

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false } // <-- debugging purposes only
    )
  ],
  exports: [
    RouterModule
  ]
})
// @NgModule({
//   imports
// })
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/app.router.ts